<div class="vs" [class.is-dark]="isDarkMode()">
  <!-- ======================= Title, status cards, primary action (one row) ======================= -->
  <div class="vs-top">
    <div class="vs-top__title">
      <span class="vs-eyebrow">Cargo heating</span>
      <h1>Voyage summary</h1>
      <p><b>Heat plans, status and monitoring across the fleet</b></p>
    </div>

    <section class="vs-kpis" *ngIf="!isCardsLoading; else vsKpisLoading" aria-label="Voyage status summary">
      <div class="vs-kpi vs-kpi--total" title="All voyages on record">
        <span class="vs-kpi__icon"><mat-icon>sailing</mat-icon></span>
        <span class="vs-kpi__label">Total voyages</span>
        <span class="vs-kpi__value">{{ totalVessels }}</span>
        <span class="vs-kpi__dist" aria-hidden="true">
          <span class="is-running" [style.width.%]="percentOfTotal(runningCount)"></span>
          <span class="is-not-started" [style.width.%]="percentOfTotal(notStartedCount)"></span>
          <span class="is-completed" [style.width.%]="percentOfTotal(completedCount)"></span>
        </span>
        <span class="vs-kpi__hint">All voyages on record</span>
      </div>

      <button type="button" class="vs-kpi vs-kpi--running" (click)="showVoyageStatus('active')"
        [class.is-active]="!isSpecialVoyage && !filterNotStartedOnly" [disabled]="isTableLoading"
        [title]="percentOfTotal(runningCount) + '% of voyages · at sea now. Show active voyages (running and yet to start)'">
        <span class="vs-kpi__icon"><mat-icon>directions_boat</mat-icon></span>
        <span class="vs-kpi__label">Running <em>{{ percentOfTotal(runningCount) }}%</em></span>
        <span class="vs-kpi__value">{{ runningCount }}</span>
        <span class="vs-kpi__bar" aria-hidden="true"><span [style.width.%]="percentOfTotal(runningCount)"></span></span>
        <span class="vs-kpi__hint">At sea now</span>
      </button>

      <button type="button" class="vs-kpi vs-kpi--not-started" (click)="showVoyageStatus('not-started')"
        [class.is-active]="!isSpecialVoyage && filterNotStartedOnly" [disabled]="isTableLoading"
        [title]="percentOfTotal(notStartedCount) + '% of voyages · awaiting start. Show only voyages that have not started'">
        <span class="vs-kpi__icon"><mat-icon>schedule</mat-icon></span>
        <span class="vs-kpi__label">Yet to start <em>{{ percentOfTotal(notStartedCount) }}%</em></span>
        <span class="vs-kpi__value">{{ notStartedCount }}</span>
        <span class="vs-kpi__bar" aria-hidden="true"><span
            [style.width.%]="percentOfTotal(notStartedCount)"></span></span>
        <span class="vs-kpi__hint">Awaiting start</span>
      </button>

      <button type="button" class="vs-kpi vs-kpi--completed" (click)="showVoyageStatus('completed')"
        [class.is-active]="isSpecialVoyage" [disabled]="isTableLoading"
        [title]="percentOfTotal(completedCount) + '% of voyages · report stage. Show completed voyages'">
        <span class="vs-kpi__icon"><mat-icon>task_alt</mat-icon></span>
        <span class="vs-kpi__label">Completed <em>{{ percentOfTotal(completedCount) }}%</em></span>
        <span class="vs-kpi__value">{{ completedCount }}</span>
        <span class="vs-kpi__bar" aria-hidden="true"><span
            [style.width.%]="percentOfTotal(completedCount)"></span></span>
        <span class="vs-kpi__hint">Report stage</span>
      </button>
      <!-- <div class="vs-kpi logs-started">
        <span class="vs-kpi__value">{{ logsInsertedCount }}</span>
        <span class="vs-kpi__label">Temperatures Logs Recorded</span>
      </div> -->
    </section>
    <ng-template #vsKpisLoading>
      <div class="vs-kpis vs-kpis--loading"><app-ch-skeleton variant="tiles" [tiles]="4"></app-ch-skeleton></div>
    </ng-template>

    <div class="vs-top__actions">
      <button type="button" *ngIf="username === 'Meraki - Operations'" class="vs-btn vs-btn--primary"
        (click)="newForm()" [disabled]="isNewFormLoading">
        <mat-icon [class.vs-spin]="isNewFormLoading">{{ isNewFormLoading ? 'autorenew' : 'note_add' }}</mat-icon>
        <span>{{ isNewFormLoading ? 'Loading…' : 'New voyage' }}</span>
      </button>
    </div>
  </div>

  <!-- ======================= Voyages table ======================= -->
  <section class="vs-card vs-table-card" aria-label="Voyages">
    <div class="vs-toolbar" #filterContainer>
      <div class="vs-toolbar__row">
        <div class="vs-tabs" role="tablist" aria-label="Voyage status">
          <button type="button" role="tab" class="vs-tab vs-tab--active" [class.is-active]="!isSpecialVoyage"
            (click)="setVoyageView('running')" [disabled]="isTableLoading" [attr.aria-selected]="!isSpecialVoyage"
            title="View Active Voyages (Running & Yet to Start)">
            <span class="vs-live-dot" *ngIf="!isSpecialVoyage" aria-hidden="true"></span>
            <mat-icon *ngIf="isSpecialVoyage">sailing</mat-icon>
            <span>Active voyages</span>
            <span class="vs-tab__count" *ngIf="!isCardsLoading">{{ activeVoyageCount }}</span>
          </button>
          <button type="button" role="tab" class="vs-tab vs-tab--completed" [class.is-active]="isSpecialVoyage"
            (click)="setVoyageView('completed')" [disabled]="isTableLoading" [attr.aria-selected]="isSpecialVoyage"
            title="View Completed Voyages">
            <mat-icon>task_alt</mat-icon>
            <span>Completed voyages</span>
            <span class="vs-tab__count" *ngIf="!isCardsLoading">{{ completedCount }}</span>
          </button>
        </div>

        <label class="vs-search">
          <mat-icon>search</mat-icon>
          <input type="text" placeholder="Search vessel, IMO, client, PIC, cargo…" [value]="searchQuery"
            (input)="onSearchChange($any($event.target).value)" aria-label="Search voyages" />
          <button type="button" class="vs-search__clear" *ngIf="searchQuery" (click)="clearSearch()"
            aria-label="Clear search" title="Clear search">
            <mat-icon>close</mat-icon>
          </button>
        </label>

        <div class="vs-toolbar__end">
          <span class="vs-records" *ngIf="!isTableLoading">
            <b>{{ filteredData?.length || 0 }}</b>
            {{ isSpecialVoyage ? 'completed' : 'active' }} voyage{{ (filteredData?.length || 0) === 1 ? '' : 's' }}
          </span>
          <button type="button" class="vs-icon-btn" [class.has-active]="hasActiveFilters" (click)="clearClick()"
            title="Reset all filters" aria-label="Reset all filters">
            <mat-icon>restart_alt</mat-icon>
          </button>
          <button type="button" class="vs-btn" (click)="downloadCSV()" title="Download CSV export">
            <mat-icon>download</mat-icon>
            <span>CSV</span>
          </button>
        </div>
      </div>

      <div class="vs-toolbar__row vs-filters">
        <span class="vs-filters__label"><mat-icon>tune</mat-icon>Filters</span>

        <!-- Client -->
        <div class="vs-ms" *ngIf="showClientFilter">
          <button type="button" class="vs-ms__box" [class.has-selection]="selectedClients.length > 0"
            [class.is-open]="clientDropdownOpen" (click)="toggleClientDropdown($event)"
            [attr.aria-expanded]="clientDropdownOpen">
            <mat-icon class="vs-ms__icon">corporate_fare</mat-icon>
            <span class="vs-ms__label" [title]="selectedClients.join(', ')">{{ selectedClients.length ?
              (selectedClients.length === clientOptions.length ? 'All clients'
              : (selectedClients.length === 1 ? selectedClients[0] : selectedClients.length + ' clients')) :
              'Client' }}</span>
            <span class="vs-ms__count"
              *ngIf="selectedClients.length > 0 && selectedClients.length < clientOptions.length">{{
              selectedClients.length }}</span>
            <mat-icon class="vs-ms__clear" *ngIf="selectedClients.length > 0"
              (click)="clearSingleFilter('client', $event)" title="Clear client filter">close</mat-icon>
            <mat-icon class="vs-ms__arrow">expand_more</mat-icon>
          </button>
          <div class="vs-ms__panel" *ngIf="clientDropdownOpen" (click)="$event.stopPropagation()">
            <div class="vs-ms__search">
              <mat-icon>search</mat-icon>
              <input type="text" placeholder="Search client…" (input)="clientSearchQuery = $any($event.target).value"
                [value]="clientSearchQuery" />
              <mat-icon class="vs-ms__search-clear" *ngIf="clientSearchQuery"
                (click)="clientSearchQuery = ''">close</mat-icon>
            </div>
            <div class="vs-ms__all">
              <label class="vs-check">
                <input type="checkbox" (change)="toggleAllClients($event); applyFilters()"
                  [checked]="isAllClientsSelected()" />
                <span class="vs-check__box"></span>
                <span>Select all</span>
              </label>
              <span class="vs-ms__status">{{ selectedClients.length }} of {{ clientOptions.length }}</span>
            </div>
            <div class="vs-ms__list">
              <label class="vs-check vs-ms__option" *ngFor="let client of getFilteredClients()"
                [class.is-selected]="selectedClients.includes(client)">
                <input type="checkbox" (change)="onClientChange($event, client); applyFilters()"
                  [checked]="selectedClients.includes(client)" />
                <span class="vs-check__box"></span>
                <span class="vs-ms__name">{{ client }}</span>
              </label>
              <div class="vs-ms__empty" *ngIf="getFilteredClients().length === 0">
                <mat-icon>search_off</mat-icon>No clients found
              </div>
            </div>
          </div>
        </div>

        <!-- Vessel -->
        <div class="vs-ms">
          <button type="button" class="vs-ms__box" [class.has-selection]="selectedVessels.length > 0"
            [class.is-open]="vesselDropdownOpen" (click)="toggleVesselDropdown($event)"
            [attr.aria-expanded]="vesselDropdownOpen">
            <mat-icon class="vs-ms__icon">directions_boat</mat-icon>
            <span class="vs-ms__label" [title]="selectedVessels.join(', ')">{{ selectedVessels.length ?
              (selectedVessels.length === vesselOptions.length ? 'All vessels'
              : (selectedVessels.length === 1 ? selectedVessels[0] : selectedVessels.length + ' vessels')) :
              'Vessel' }}</span>
            <span class="vs-ms__count"
              *ngIf="selectedVessels.length > 0 && selectedVessels.length < vesselOptions.length">{{
              selectedVessels.length }}</span>
            <mat-icon class="vs-ms__clear" *ngIf="selectedVessels.length > 0"
              (click)="clearSingleFilter('vessel', $event)" title="Clear vessel filter">close</mat-icon>
            <mat-icon class="vs-ms__arrow">expand_more</mat-icon>
          </button>
          <div class="vs-ms__panel" *ngIf="vesselDropdownOpen" (click)="$event.stopPropagation()">
            <div class="vs-ms__search">
              <mat-icon>search</mat-icon>
              <input type="text" placeholder="Search vessel…" (input)="vesselSearchQuery = $any($event.target).value"
                [value]="vesselSearchQuery" />
              <mat-icon class="vs-ms__search-clear" *ngIf="vesselSearchQuery"
                (click)="vesselSearchQuery = ''">close</mat-icon>
            </div>
            <div class="vs-ms__all">
              <label class="vs-check">
                <input type="checkbox" (change)="toggleAllVessels($event); applyFilters()"
                  [checked]="isAllVesselsSelected()" />
                <span class="vs-check__box"></span>
                <span>Select all</span>
              </label>
              <span class="vs-ms__status">{{ selectedVessels.length }} of {{ vesselOptions.length }}</span>
            </div>
            <div class="vs-ms__list">
              <label class="vs-check vs-ms__option" *ngFor="let vessel of getFilteredVessels()"
                [class.is-selected]="selectedVessels.includes(vessel)">
                <input type="checkbox" (change)="onVesselChange($event, vessel); applyFilters()"
                  [checked]="selectedVessels.includes(vessel)" />
                <span class="vs-check__box"></span>
                <span class="vs-ms__name">{{ vessel }}</span>
              </label>
              <div class="vs-ms__empty" *ngIf="getFilteredVessels().length === 0">
                <mat-icon>search_off</mat-icon>No vessels found
              </div>
            </div>
          </div>
        </div>

        <!-- Segment -->
        <div class="vs-ms">
          <button type="button" class="vs-ms__box" [class.has-selection]="selectedSegments.length > 0"
            [class.is-open]="segmentDropdownOpen" (click)="toggleSegmentDropdown($event)"
            [attr.aria-expanded]="segmentDropdownOpen">
            <mat-icon class="vs-ms__icon">view_quilt</mat-icon>
            <span class="vs-ms__label" [title]="selectedSegments.join(', ')">{{ selectedSegments.length ?
              (selectedSegments.length === segmentOptions.length ? 'All segments'
              : (selectedSegments.length === 1 ? selectedSegments[0] : selectedSegments.length + ' segments')) :
              'Segment' }}</span>
            <span class="vs-ms__count"
              *ngIf="selectedSegments.length > 0 && selectedSegments.length < segmentOptions.length">{{
              selectedSegments.length }}</span>
            <mat-icon class="vs-ms__clear" *ngIf="selectedSegments.length > 0"
              (click)="clearSingleFilter('segment', $event)" title="Clear segment filter">close</mat-icon>
            <mat-icon class="vs-ms__arrow">expand_more</mat-icon>
          </button>
          <div class="vs-ms__panel" *ngIf="segmentDropdownOpen" (click)="$event.stopPropagation()">
            <div class="vs-ms__search">
              <mat-icon>search</mat-icon>
              <input type="text" placeholder="Search segment…" (input)="segmentSearchQuery = $any($event.target).value"
                [value]="segmentSearchQuery" />
              <mat-icon class="vs-ms__search-clear" *ngIf="segmentSearchQuery"
                (click)="segmentSearchQuery = ''">close</mat-icon>
            </div>
            <div class="vs-ms__all">
              <label class="vs-check">
                <input type="checkbox" (change)="toggleAllSegments($event); applyFilters()"
                  [checked]="isAllSegmentsSelected()" />
                <span class="vs-check__box"></span>
                <span>Select all</span>
              </label>
              <span class="vs-ms__status">{{ selectedSegments.length }} of {{ segmentOptions.length }}</span>
            </div>
            <div class="vs-ms__list">
              <label class="vs-check vs-ms__option" *ngFor="let seg of getFilteredSegments()"
                [class.is-selected]="selectedSegments.includes(seg)">
                <input type="checkbox" (change)="onSegmentChange($event, seg); applyFilters()"
                  [checked]="selectedSegments.includes(seg)" />
                <span class="vs-check__box"></span>
                <span class="vs-ms__name">{{ seg }}</span>
              </label>
              <div class="vs-ms__empty" *ngIf="getFilteredSegments().length === 0">
                <mat-icon>search_off</mat-icon>No segments found
              </div>
            </div>
          </div>
        </div>

        <!-- Cargo grade -->
        <div class="vs-ms">
          <button type="button" class="vs-ms__box" [class.has-selection]="selectedCargos.length > 0"
            [class.is-open]="cargoDropdownOpen" (click)="toggleCargoDropdown($event)"
            [attr.aria-expanded]="cargoDropdownOpen">
            <mat-icon class="vs-ms__icon">opacity</mat-icon>
            <span class="vs-ms__label" [title]="selectedCargos.join(', ')">{{ selectedCargos.length ?
              (selectedCargos.length === cargoOptions.length ? 'All grades'
              : (selectedCargos.length === 1 ? selectedCargos[0] : selectedCargos.length + ' grades')) :
              'Cargo grade' }}</span>
            <span class="vs-ms__count"
              *ngIf="selectedCargos.length > 0 && selectedCargos.length < cargoOptions.length">{{
              selectedCargos.length }}</span>
            <mat-icon class="vs-ms__clear" *ngIf="selectedCargos.length > 0"
              (click)="clearSingleFilter('cargo', $event)" title="Clear cargo filter">close</mat-icon>
            <mat-icon class="vs-ms__arrow">expand_more</mat-icon>
          </button>
          <div class="vs-ms__panel" *ngIf="cargoDropdownOpen" (click)="$event.stopPropagation()">
            <div class="vs-ms__search">
              <mat-icon>search</mat-icon>
              <input type="text" placeholder="Search cargo…" (input)="cargoSearchQuery = $any($event.target).value"
                [value]="cargoSearchQuery" />
              <mat-icon class="vs-ms__search-clear" *ngIf="cargoSearchQuery"
                (click)="cargoSearchQuery = ''">close</mat-icon>
            </div>
            <div class="vs-ms__all">
              <label class="vs-check">
                <input type="checkbox" (change)="toggleAllCargos($event); applyFilters()"
                  [checked]="isAllCargosSelected()" />
                <span class="vs-check__box"></span>
                <span>Select all</span>
              </label>
              <span class="vs-ms__status">{{ selectedCargos.length }} of {{ cargoOptions.length }}</span>
            </div>
            <div class="vs-ms__list">
              <label class="vs-check vs-ms__option" *ngFor="let cargo of getFilteredCargos()"
                [class.is-selected]="selectedCargos.includes(cargo)">
                <input type="checkbox" (change)="onCargoChange($event, cargo); applyFilters()"
                  [checked]="selectedCargos.includes(cargo)" />
                <span class="vs-check__box"></span>
                <span class="vs-ms__name">{{ cargo }}</span>
              </label>
              <div class="vs-ms__empty" *ngIf="getFilteredCargos().length === 0">
                <mat-icon>search_off</mat-icon>No cargo grades found
              </div>
            </div>
          </div>
        </div>

        <!-- Heating setup -->
        <div class="vs-ms">
          <button type="button" class="vs-ms__box" [class.has-selection]="selectedHeatingTypes.length > 0"
            [class.is-open]="heatingTypeDropdownOpen" (click)="toggleHeatingTypeDropdown($event)"
            [attr.aria-expanded]="heatingTypeDropdownOpen">
            <mat-icon class="vs-ms__icon">thermostat</mat-icon>
            <span class="vs-ms__label" [title]="selectedHeatingTypes.join(', ')">{{ selectedHeatingTypes.length ?
              (selectedHeatingTypes.length === heatingTypeOptions.length ? 'All heating types'
              : (selectedHeatingTypes.length === 1 ? selectedHeatingTypes[0] : selectedHeatingTypes.length + ' heating
              types')) :
              'Heating setup' }}</span>
            <span class="vs-ms__count"
              *ngIf="selectedHeatingTypes.length > 0 && selectedHeatingTypes.length < heatingTypeOptions.length">{{
              selectedHeatingTypes.length }}</span>
            <mat-icon class="vs-ms__clear" *ngIf="selectedHeatingTypes.length > 0"
              (click)="clearSingleFilter('heatingType', $event)" title="Clear heating filter">close</mat-icon>
            <mat-icon class="vs-ms__arrow">expand_more</mat-icon>
          </button>
          <div class="vs-ms__panel" *ngIf="heatingTypeDropdownOpen" (click)="$event.stopPropagation()">
            <div class="vs-ms__search">
              <mat-icon>search</mat-icon>
              <input type="text" placeholder="Search heating type…"
                (input)="heatingTypeSearchQuery = $any($event.target).value" [value]="heatingTypeSearchQuery" />
              <mat-icon class="vs-ms__search-clear" *ngIf="heatingTypeSearchQuery"
                (click)="heatingTypeSearchQuery = ''">close</mat-icon>
            </div>
            <div class="vs-ms__all">
              <label class="vs-check">
                <input type="checkbox" (change)="toggleAllHeatingTypes($event); applyFilters()"
                  [checked]="isAllHeatingTypesSelected()" />
                <span class="vs-check__box"></span>
                <span>Select all</span>
              </label>
              <span class="vs-ms__status">{{ selectedHeatingTypes.length }} of {{ heatingTypeOptions.length }}</span>
            </div>
            <div class="vs-ms__list">
              <label class="vs-check vs-ms__option" *ngFor="let heatingType of getFilteredHeatingTypes()"
                [class.is-selected]="selectedHeatingTypes.includes(heatingType)">
                <input type="checkbox" (change)="onHeatingTypeChange($event, heatingType); applyFilters()"
                  [checked]="selectedHeatingTypes.includes(heatingType)" />
                <span class="vs-check__box"></span>
                <span class="vs-ms__name">{{ heatingType }}</span>
              </label>
              <div class="vs-ms__empty" *ngIf="getFilteredHeatingTypes().length === 0">
                <mat-icon>search_off</mat-icon>No heating setups found
              </div>
            </div>
          </div>
        </div>

        <!-- Latest discharge date range -->
        <div class="vs-date"
          [class.has-value]="filterForm.controls['from_date'].value || filterForm.controls['to_date'].value"
          (click)="rangePicker.open()">
          <mat-icon class="vs-date__icon">calendar_month</mat-icon>
          <span class="vs-date__label">Discharge</span>
          <mat-date-range-input [formGroup]="filterForm" [rangePicker]="rangePicker" class="vs-date__input"
            separator="→">
            <input matStartDate formControlName="from_date" placeholder="From" readonly (click)="rangePicker.open()"
              (dateChange)="applyFilters()" aria-label="Latest discharge date from" />
            <input matEndDate formControlName="to_date" placeholder="To" readonly (click)="rangePicker.open()"
              (dateChange)="applyFilters()" aria-label="Latest discharge date to" />
          </mat-date-range-input>
          <mat-icon class="vs-date__clear"
            *ngIf="filterForm.controls['from_date'].value || filterForm.controls['to_date'].value"
            (click)="clearDateFilter($event)" title="Clear date range">close</mat-icon>
          <mat-icon class="vs-date__info" (click)="$event.stopPropagation()"
            matTooltip="This date range filter is applied along the latest discharge port date"
            matTooltipClass="custom-modern-tooltip" matTooltipPosition="above">info_outline</mat-icon>
          <mat-datepicker-toggle matIconSuffix [for]="rangePicker"
            (click)="$event.stopPropagation()"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker
            [panelClass]="isDarkMode() ? ['vs-datepicker', 'vs-datepicker--dark'] : ['vs-datepicker']">
            <mat-date-range-picker-actions>
              <button type="button" class="vs-dp-btn" matDateRangePickerCancel>Cancel</button>
              <button type="button" class="vs-dp-btn vs-dp-btn--primary" matDateRangePickerApply
                (click)="applyFilters()">Apply</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </div>

        <span class="vs-flag" *ngIf="filterNotStartedOnly && !isSpecialVoyage">
          <mat-icon>schedule</mat-icon>
          Yet to start only
          <button type="button" (click)="toggleNotStartedFilter()" aria-label="Show all active voyages"
            title="Show all active voyages"><mat-icon>close</mat-icon></button>
        </span>
      </div>
    </div>

    <!-- Table -->
    <div class="vs-table-body" *ngIf="!graph">
      <div class="vs-table-loading" *ngIf="isTableLoading">
        <app-ch-skeleton variant="table" [rows]="8" [cols]="8"></app-ch-skeleton>
      </div>

      <div class="vs-scroll" *ngIf="!isTableLoading">
        <table class="vs-table" matSort (matSortChange)="sortData($event)">
          <colgroup>
            <col style="width: 72px" />
            <col style="width: 200px" />
            <col style="width: 110px" />
            <col style="width: 120px" />
            <col style="width: 160px" *ngIf="showClientFilter" />
            <col style="width: 100px" *ngIf="!isClientLogin" />
            <col style="width: 140px" />
            <col style="width: 190px" *ngIf="!isSpecialVoyage" />
            <col style="width: 130px" />
            <col style="width: 170px" />
            <col style="width: 120px" />
            <col style="width: 110px" />
          </colgroup>
          <thead>
            <tr>
              <th class="vs-col-sn" scope="col">#</th>
              <th mat-sort-header="vessel_name" class="vs-col-vessel" scope="col">Vessel</th>
              <th mat-sort-header="vessel_imo" scope="col">IMO</th>
              <th mat-sort-header="segment" scope="col">Segment</th>
              <th mat-sort-header="client" scope="col" *ngIf="showClientFilter">Client</th>
              <th mat-sort-header="pic" scope="col" *ngIf="!isClientLogin">PIC</th>
              <th mat-sort-header="voyage_status" scope="col">Status</th>
              <th mat-sort-header="hp_due" scope="col" *ngIf="!isSpecialVoyage"
                title="Next heat plan is due 2 days before the latest plan ends. Sorts by the send-by date, nearest first.">
                Next heat
                plan</th>
              <th mat-sort-header="cargo_type" scope="col">Cargo grade</th>
              <th mat-sort-header="heating_type" scope="col">Heating setup</th>
              <th class="vs-col-action" scope="col">Details</th>
              <th class="vs-col-action" scope="col">Monitoring</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let element of paginatedData; let i = index" class="vs-row"
              [ngClass]="getVoyageRowClass(element)" (click)="editRow(element)"
              (keydown.enter)="$event.target === $event.currentTarget && editRow(element)" tabindex="0"
              [attr.aria-label]="'Open heat plan for ' + element.vessel_name">
              <td class="vs-col-sn">
                <span class="vs-sn">{{ currentPage * itemsPerPage + i + 1 }}</span>
                <button type="button" class="vs-row-peek" (click)="openDetailsModal(element, $event)"
                  title="View full vessel details" aria-label="View full vessel details">
                  <mat-icon>open_in_new</mat-icon>
                </button>
              </td>
              <td class="vs-col-vessel">
                <span class="vs-vessel">
                  <span class="vs-vessel__avatar" aria-hidden="true">{{ (element.vessel_name || '?').charAt(0) }}</span>
                  <span class="vs-vessel__name">{{ element.vessel_name }}</span>
                </span>
              </td>
              <td class="vs-num">{{ element.vessel_imo }}</td>
              <td>{{ element.segment }}</td>
              <td *ngIf="showClientFilter">{{ element.client }}</td>
              <td *ngIf="!isClientLogin"><span class="vs-pic">{{ element.pic || '—' }}</span></td>
              <td>
                <span class="vs-status" [ngClass]="getVoyageStatusClass(element)">{{ getVoyageStatus(element) }}</span>
              </td>
              <td *ngIf="!isSpecialVoyage">
                <span class="vs-due" *ngIf="element.hp_due as due; else vsDash" [ngClass]="'is-' + due.level"
                  [title]="heatplanDueTitle(due)">
                  <span class="vs-due__dot" aria-hidden="true"></span>
                  <span class="vs-due__text">
                    <b>{{ due.label }}</b>
                    <small *ngIf="due.dueTime !== null">by {{ formatDueDate(due.dueTime) }} · after HP {{
                      due.latestPlanNumber }}</small>
                    <small *ngIf="due.port">{{ due.port.arriving ? 'arrives' : 'arrived' }} {{
                      formatDueDate(due.port.arrival) }} · HP {{ due.latestPlanNumber }} ends {{
                      formatDueDate(due.latestPlanEnd) }}</small>
                  </span>
                </span>
              </td>
              <td>
                <span class="vs-cargo" *ngIf="element.cargo_type; else vsDash">{{ element.cargo_type }}</span>
              </td>
              <td>
                <span
                  *ngIf="element.heating_type || element.fleet_data?.heatingCoilsOrDeckHeatExchanger; else vsDash">{{
                  element.heating_type || element.fleet_data?.heatingCoilsOrDeckHeatExchanger }}</span>
              </td>
              <td class="vs-col-action">
                <button type="button" class="vs-row-btn" (click)="openDetailsModal(element, $event)"
                  title="Click for overview of voyage">
                  <mat-icon>analytics</mat-icon>
                  <span>Overview</span>
                </button>
              </td>
              <td class="vs-col-action">
                <button type="button" class="vs-row-icon" (click)="openVoyageMonitoring(element, $event)"
                  title="Open voyage monitoring" aria-label="Open voyage monitoring">
                  <mat-icon>monitor_heart</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="vs-no-rows" *ngIf="!(filteredData?.length)">
          <span class="vs-no-rows__icon"><mat-icon>{{ hasActiveFilters ? 'filter_alt_off' : 'inbox' }}</mat-icon></span>
          <h3>{{ hasActiveFilters ? 'No voyages match these filters' : (isSpecialVoyage ? 'No completed voyages yet' :
            'No active voyages') }}</h3>
          <p *ngIf="hasActiveFilters">Try removing a filter or clearing the search.</p>
          <button type="button" class="vs-btn" *ngIf="hasActiveFilters" (click)="clearClick()">
            <mat-icon>restart_alt</mat-icon>
            <span>Reset filters</span>
          </button>
        </div>
      </div>
    </div>

    <footer class="vs-table-foot" *ngIf="!graph && !isTableLoading">
      <span class="vs-table-foot__hint">
        <mat-icon>touch_app</mat-icon>
        Click on any row to open details
      </span>
      <mat-paginator class="vs-paginator" [length]="filteredData?.length || 0" [pageSize]="itemsPerPage"
        [pageIndex]="currentPage" hidePageSize="true" (page)="onPageChange($event)" showFirstLastButtons>
      </mat-paginator>
    </footer>
  </section>

  <ng-template #vsDash><span class="vs-dash">—</span></ng-template>

  <!-- ======================= Voyage overview dialog ======================= -->
  <!-- Pinned to this page's own area: the app header and sidebar are drawn above a full-screen overlay. -->
  <div class="vs-overlay" *ngIf="modalElement" (click)="closeDetailsModal()" [style.top.px]="modalInset.top"
    [style.left.px]="modalInset.left">
    <div class="vs-dialog" role="dialog" aria-modal="true" aria-labelledby="vs-dialog-title"
      (click)="$event.stopPropagation()">
      <header class="vs-dialog__head">
        <span class="vs-vessel__avatar vs-vessel__avatar--lg" aria-hidden="true">{{ (modalElement.vessel_name ||
          '?').charAt(0) }}</span>
        <div class="vs-dialog__titles">
          <div class="vs-dialog__title-row">
            <h3 id="vs-dialog-title">{{ modalElement.vessel_name }}</h3>
            <span class="vs-status" [ngClass]="getVoyageStatusClass(modalElement)">{{ getVoyageStatus(modalElement)
              }}</span>
          </div>
          <p class="vs-dialog__meta">
            <span>IMO <b>{{ modalElement.vessel_imo }}</b></span>
            <span *ngIf="modalElement.voyage_no">Voyage <b>{{ modalElement.voyage_no }}</b></span>
            <span *ngIf="modalElement.cargo_type" class="vs-dialog__cargo">
              <mat-icon>local_fire_department</mat-icon>{{ modalElement.cargo_type }}
            </span>
            <span *ngIf="modalElement.client">{{ modalElement.client }}</span>
            <span *ngIf="modalElement.segment">{{ modalElement.segment }}</span>
          </p>
          <div class="vs-dialog__chips">
            <span class="vs-chip" *ngIf="totalCargoQty !== null && totalCargoQty !== undefined">
              <mat-icon>inventory_2</mat-icon>
              <ng-container *ngIf="totalCargoQty > 0; else vsNoCargo">Total cargo <b>{{ totalCargoQty | number }}
                  MT</b></ng-container>
              <ng-template #vsNoCargo>Cargo yet to load</ng-template>
            </span>
            <span class="vs-chip is-loading" *ngIf="isLoadingVoyageTotals">
              <mat-icon class="vs-spin">sync</mat-icon>Loading cargo…
            </span>
            <span class="vs-chip" *ngIf="totalDaysOfVoyage !== null && totalDaysOfVoyage !== undefined">
              <mat-icon>schedule</mat-icon>
              Voyage duration <b>{{ totalDaysOfVoyage }} {{ totalDaysOfVoyage === 1 ? 'day' : 'days' }}</b>
            </span>
            <span class="vs-chip is-loading" *ngIf="isLoadingVoyageTotals">
              <mat-icon class="vs-spin">sync</mat-icon>Loading duration…
            </span>
            <span class="vs-chip" *ngIf="modalElement.heating_type">
              <mat-icon>hvac</mat-icon>{{ modalElement.heating_type }}
            </span>
            <span class="vs-chip" *ngIf="modalElement.pic">
              <mat-icon>person</mat-icon>PIC <b>{{ modalElement.pic }}</b>
            </span>
          </div>
        </div>
        <button type="button" class="vs-icon-btn vs-icon-btn--ghost" (click)="closeDetailsModal()" title="Close (Esc)"
          aria-label="Close details">
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <!-- Voyage progress: first load departure → last discharge arrival -->
      <div class="vs-journey" *ngIf="modalInsights?.progress as pg">
        <div class="vs-journey__end">
          <span class="vs-journey__label">Departed</span>
          <b>{{ pg.fromPort }}</b>
          <span class="vs-journey__date">{{ formatEpochDate(pg.fromTime) }}</span>
        </div>
        <div class="vs-journey__mid">
          <div class="vs-journey__track" role="progressbar" [attr.aria-valuenow]="pg.pct | number: '1.0-0'"
            aria-valuemin="0" aria-valuemax="100" aria-label="Voyage progress">
            <span class="vs-journey__fill" [style.width.%]="pg.pct"></span>
            <span class="vs-journey__ship" [style.left.%]="pg.pct"><mat-icon>directions_boat</mat-icon></span>
          </div>
          <span class="vs-journey__caption" [ngSwitch]="pg.phase">
            <ng-container *ngSwitchCase="'before'">Not departed yet · {{ pg.totalDays }} days planned</ng-container>
            <ng-container *ngSwitchCase="'arrived'">Final discharge date reached · {{ pg.totalDays }} days
              planned</ng-container>
            <ng-container *ngSwitchDefault>Day <b>{{ pg.dayNo }}</b> of {{ pg.totalDays }} · <b>{{ pg.daysLeft
                }}</b> {{ pg.daysLeft === 1 ? 'day' : 'days' }} to {{ pg.toPort }}</ng-container>
          </span>
        </div>
        <div class="vs-journey__end is-to">
          <span class="vs-journey__label">Arrives</span>
          <b>{{ pg.toPort }}</b>
          <span class="vs-journey__date">{{ formatEpochDate(pg.toTime) }}</span>
        </div>
      </div>

      <div class="vs-dialog__body">
        <!-- Fuel & heating consumption -->
        <section class="vs-tile vs-tile--consumption">
          <header class="vs-tile__head">
            <span class="vs-tile__icon"><mat-icon>local_fire_department</mat-icon></span>
            <h4>Fuel &amp; heating consumption</h4>
            <button type="button" class="vs-copy" (click)="copyTileData('consumption', $event)"
              [class.is-copied]="copiedTile === 'Fuel & Heating Consumption'"
              [title]="copiedTile === 'Fuel & Heating Consumption' ? 'Copied data to clipboard' : 'Copy formatted tile data'">
              <mat-icon>{{ copiedTile === 'Fuel & Heating Consumption' ? 'check' : 'content_copy' }}</mat-icon>
              <span>{{ copiedTile === 'Fuel & Heating Consumption' ? 'Copied' : 'Copy' }}</span>
            </button>
          </header>
          <!-- Master logs vs heat plan logs, same figures as the comparison page with every plan selected -->
          <dl class="vs-tile__grid">
            <div>
              <dt matTooltip="Every master log of the voyage (HFO + MGO)" matTooltipPosition="above">Total bunker cons.
              </dt>
              <dd *ngIf="isLoadingModalConsumption; else vsMasterCons" class="vs-cons__loading">
                <mat-icon class="vs-spin">sync</mat-icon>
              </dd>
              <ng-template #vsMasterCons>
                <dd>{{ modalConsumption ? (modalConsumption.masterTotalMt | number: '1.1-1') : '—' }}
                  <small>MT</small>
                </dd>
                <span class="vs-cons__split" *ngIf="modalConsumption?.masterSplit as split"
                  matTooltip="Split in the heat plan's raise : maintain ratio" matTooltipPosition="below">
                  Raise <b>{{ split.raise | number: '1.1-1' }}</b> · Maintain <b>{{ split.maintain | number: '1.1-1'
                    }}</b> MT
                </span>
              </ng-template>
            </div>
            <div>
              <dt matTooltip="Master logs dated on a heat plan day only" matTooltipPosition="above">Master · HP days
              </dt>
              <dd *ngIf="isLoadingModalConsumption; else vsMasterPlanDaysCons" class="vs-cons__loading">
                <mat-icon class="vs-spin">sync</mat-icon>
              </dd>
              <ng-template #vsMasterPlanDaysCons>
                <ng-container *ngIf="modalConsumption?.planDays && modalConsumption as mc; else vsNoMasterPlanDaysCons">
                  <dd>{{ mc.masterPlanDaysMt | number: '1.1-1' }} <small>MT</small></dd>
                  <span class="vs-cons__split" *ngIf="mc.masterPlanDaysSplit as split"
                    matTooltip="Split in the heat plan's raise : maintain ratio" matTooltipPosition="below">
                    Raise <b>{{ split.raise | number: '1.1-1' }}</b> · Maintain <b>{{ split.maintain | number: '1.1-1'
                      }}</b> MT
                  </span>
                  <span class="vs-cons__split">{{ mc.masterReportedPlanDays }} of {{ mc.planDays }} plan days
                    reported</span>
                </ng-container>
                <ng-template #vsNoMasterPlanDaysCons>
                  <dd>—</dd>
                </ng-template>
              </ng-template>
            </div>
            <div>
              <dt matTooltip="Planned consumption up to the last master report" matTooltipPosition="above">Est. cons.
                (HP)</dt>
              <dd *ngIf="isLoadingModalConsumption; else vsPlanCons" class="vs-cons__loading">
                <mat-icon class="vs-spin">sync</mat-icon>
              </dd>
              <ng-template #vsPlanCons>
                <ng-container *ngIf="modalConsumption?.planDays && modalConsumption as mc; else vsNoPlanCons">
                  <dd>{{ mc.planTillLastReportMt | number: '1.1-1' }} <small>MT</small></dd>
                  <span class="vs-cons__split"
                    matTooltip="Raise = raise consumption; Maintain = maintain + DHE + AE + pipeline loss"
                    matTooltipPosition="below">
                    Raise <b>{{ mc.planSplit.raise | number: '1.1-1' }}</b> · Maintain <b>{{ mc.planSplit.maintain |
                      number: '1.1-1' }}</b> MT
                  </span>
                </ng-container>
                <ng-template #vsNoPlanCons>
                  <dd>—</dd>
                </ng-template>
              </ng-template>
            </div>
          </dl>
          <p class="vs-tile__note" *ngIf="!isLoadingModalConsumption">
            <ng-container [ngSwitch]="true">
              <ng-container *ngSwitchCase="modalConsumptionError === 'master'">Couldn't load the master logs.
              </ng-container>
              <ng-container *ngSwitchCase="modalConsumptionError === 'plan'">Couldn't load the heat plan logs.
              </ng-container>
              <ng-container *ngSwitchCase="!modalConsumption?.planDays">No heat plan sent yet.</ng-container>
              <ng-container *ngSwitchCase="!modalConsumption?.lastMasterPlanDate">No master report on a heat plan day
                yet · full plan {{ formatConsumptionMt(modalConsumption?.planFullMt) }}.</ng-container>
              <ng-container *ngSwitchDefault>Plan up to {{ modalConsumption?.lastMasterPlanDate | date: 'd MMM y' }}
                (last master report) · full plan {{ formatConsumptionMt(modalConsumption?.planFullMt) }}.
              </ng-container>
            </ng-container>
          </p>
        </section>

        <!-- Cargo temperatures -->
        <section class="vs-tile vs-tile--temp">
          <header class="vs-tile__head">
            <span class="vs-tile__icon"><mat-icon>device_thermostat</mat-icon></span>
            <h4>Cargo temperatures</h4>
            <button type="button" class="vs-copy" (click)="copyTileData('temp', $event)"
              [class.is-copied]="copiedTile === 'Cargo Temperatures'"
              [title]="copiedTile === 'Cargo Temperatures' ? 'Copied data to clipboard' : 'Copy formatted tile data'">
              <mat-icon>{{ copiedTile === 'Cargo Temperatures' ? 'check' : 'content_copy' }}</mat-icon>
              <span>{{ copiedTile === 'Cargo Temperatures' ? 'Copied' : 'Copy' }}</span>
            </button>
          </header>
          <!-- Cargo-weighted, from the tank profile and master logs (same as the voyage monitoring page) -->
          <div class="vs-temp" *ngIf="modalInsights?.temp as t">
            <div class="vs-temp__point"
              matTooltip="Tank load temps weighted by cargo quantity: Σ(load temp × cargo qty) ÷ Σ cargo qty"
              matTooltipPosition="above">
              <span class="vs-temp__label">Avg loaded</span>
              <span class="vs-temp__value" *ngIf="isLoadingModalConsumption; else vsLoadedTemp"><mat-icon
                  class="vs-spin vs-temp__spin">sync</mat-icon></span>
              <ng-template #vsLoadedTemp>
                <span class="vs-temp__value">{{ t.loaded === null ? '—' : (t.loaded | number: '1.1-1') }}<small
                    *ngIf="t.loaded !== null">°C</small></span>
              </ng-template>
            </div>
            <span class="vs-temp__arrow" aria-hidden="true">
              <span class="vs-temp__line"></span>
              <span class="vs-temp__delta" *ngIf="t.delta !== null" [class.is-drop]="t.delta < 0">
                {{ t.delta > 0 ? '+' : t.delta < 0 ? '−' : '±' }}{{ (t.delta < 0 ? -t.delta : t.delta) | number: '1.0-1'
                  }} °C </span>
              </span>
              <div class="vs-temp__point"
                matTooltip="Last master log day's tank temps weighted by cargo quantity (completed voyages only)"
                matTooltipPosition="above">
                <span class="vs-temp__label">Avg discharge</span>
                <span class="vs-temp__value" *ngIf="isLoadingModalConsumption; else vsDischTemp"><mat-icon
                    class="vs-spin vs-temp__spin">sync</mat-icon></span>
                <ng-template #vsDischTemp>
                  <span class="vs-temp__value">{{ t.discharge === null ? '—' : (t.discharge | number: '1.1-1')
                    }}<small *ngIf="t.discharge !== null">°C</small></span>
                </ng-template>
              </div>
          </div>
          <p class="vs-tile__note" *ngIf="!isLoadingModalConsumption && modalInsights?.temp as t">
            <ng-container [ngSwitch]="true">
              <ng-container *ngSwitchCase="modalConsumptionError === 'master'">Couldn't load the tank profile and
                master logs.</ng-container>
              <ng-container *ngSwitchCase="!isCompletedVessel(modalElement)">Discharge temperature appears once the
                voyage is completed.</ng-container>
              <ng-container *ngSwitchDefault>Discharge from the last master log ({{ t.dischargeDate | date: 'd MMM y'
                }}).</ng-container>
            </ng-container>
          </p>
        </section>

        <!-- Voyage particulars -->
        <section class="vs-tile vs-tile--voyage">
          <header class="vs-tile__head">
            <span class="vs-tile__icon"><mat-icon>alt_route</mat-icon></span>
            <h4>Voyage particulars</h4>
            <button type="button" class="vs-copy" (click)="copyTileData('voyage', $event)"
              [class.is-copied]="copiedTile === 'Voyage Particulars'"
              [title]="copiedTile === 'Voyage Particulars' ? 'Copied data to clipboard' : 'Copy formatted tile data'">
              <mat-icon>{{ copiedTile === 'Voyage Particulars' ? 'check' : 'content_copy' }}</mat-icon>
              <span>{{ copiedTile === 'Voyage Particulars' ? 'Copied' : 'Copy' }}</span>
            </button>
          </header>
          <dl class="vs-tile__grid">
            <div>
              <dt>Voyage no.</dt>
              <dd>{{ modalElement.voyage_no || '—' }}</dd>
            </div>
            <div>
              <dt>Vessel received</dt>
              <dd>{{ modalElement.form_timing_display || '—' }}</dd>
            </div>
            <div class="is-full">
              <dt class="vs-instr__label">
                <span>Heating instructions</span>
                <button type="button" class="vs-instr__edit" *ngIf="instructionsDraft === null && modalElement.voyage_id"
                  (click)="startInstructionsEdit($event)" [class.is-locked]="!canEditOverview"
                  [attr.aria-disabled]="!canEditOverview"
                  [title]="canEditOverview ? 'Edit heating instructions (saved to the voyage itinerary)' : overviewEditLockedMessage">
                  <mat-icon>{{ canEditOverview ? 'edit' : 'lock' }}</mat-icon>
                  <span>Edit</span>
                </button>
              </dt>
              <dd class="is-text is-quote" *ngIf="instructionsDraft === null; else vsInstrEditor">{{
                modalElement.fleet_data?.heatingInstructions || '—' }}</dd>
              <ng-template #vsInstrEditor>
                <dd class="vs-instr">
                  <textarea class="vs-pedit__input vs-instr__input" rows="3" [(ngModel)]="instructionsDraft"
                    [disabled]="isSavingInstructions" placeholder="e.g. Heating as per the FOSFA requirements"
                    aria-label="Heating instructions"></textarea>
                  <div class="vs-instr__actions">
                    <span class="vs-pedit__hint">Saves to the voyage itinerary</span>
                    <button type="button" class="vs-btn vs-pedit__btn" (click)="cancelInstructionsEdit()"
                      [disabled]="isSavingInstructions">Cancel</button>
                    <button type="button" class="vs-btn vs-btn--primary vs-pedit__btn" (click)="saveInstructionsEdit()"
                      [disabled]="isSavingInstructions">
                      <mat-icon>{{ isSavingInstructions ? 'hourglass_empty' : 'save' }}</mat-icon>
                      {{ isSavingInstructions ? 'Saving…' : 'Save' }}
                    </button>
                  </div>
                </dd>
              </ng-template>
            </div>
          </dl>
        </section>

        <!-- Port schedule: one route, load ports then discharge ports -->
        <section class="vs-tile vs-tile--ports">
          <header class="vs-tile__head">
            <span class="vs-tile__icon"><mat-icon>anchor</mat-icon></span>
            <h4>{{ portEdit ? 'Edit port schedule' : 'Port schedule' }}</h4>
            <ng-container *ngIf="!portEdit">
              <span class="vs-route__counts" *ngIf="modalInsights?.stops?.length">
                <span class="is-load">{{ modalElement.fleet_data?.loadPortDetails?.length || 0 }} load</span>
                <span class="is-discharge">{{ modalElement.fleet_data?.dischargePortDetails?.length || 0 }}
                  discharge</span>
              </span>
              <button type="button" class="vs-copy" *ngIf="modalElement.voyage_id" (click)="startPortEdit($event)"
                [class.is-locked]="!canEditOverview" [attr.aria-disabled]="!canEditOverview"
                [title]="canEditOverview ? 'Edit load and discharge ports (saved to the voyage itinerary)' : overviewEditLockedMessage">
                <mat-icon>{{ canEditOverview ? 'edit' : 'lock' }}</mat-icon>
                <span>Edit</span>
              </button>
              <button type="button" class="vs-copy" (click)="copyTileData('ports', $event)"
                [class.is-copied]="copiedTile === 'Port Schedule'"
                [title]="copiedTile === 'Port Schedule' ? 'Copied data to clipboard' : 'Copy formatted tile data'">
                <mat-icon>{{ copiedTile === 'Port Schedule' ? 'check' : 'content_copy' }}</mat-icon>
                <span>{{ copiedTile === 'Port Schedule' ? 'Copied' : 'Copy' }}</span>
              </button>
            </ng-container>
          </header>

          <!-- Editor: same fields as Load & discharge ports on the voyage itinerary -->
          <div class="vs-pedit" *ngIf="portEdit; else vsPortRoute">
            <div class="vs-pedit__body">
              <div class="vs-pedit__group" *ngFor="let kind of portEditKinds" [ngClass]="'is-' + kind.key">
                <div class="vs-pedit__group-head">
                  <span>{{ kind.label }} ports</span>
                  <small>{{ kind.dateLabel }} date · {{ portEdit[kind.key].length }}/{{ maxPortsPerKind }}</small>
                </div>
                <div class="vs-pedit__row" *ngFor="let row of portEdit[kind.key]; let i = index"
                  [class.is-invalid]="isPortRowInvalid(row)">
                  <span class="vs-pedit__num" aria-hidden="true">{{ i + 1 }}</span>
                  <input type="text" class="vs-pedit__input" [(ngModel)]="row.name" [disabled]="isSavingPorts"
                    [placeholder]="kind.label + ' port name'" [attr.aria-label]="kind.label + ' port ' + (i + 1)"
                    autocomplete="off" />
                  <input type="date" class="vs-pedit__input vs-pedit__input--date" [(ngModel)]="row.date"
                    [disabled]="isSavingPorts" [attr.aria-label]="kind.dateLabel + ' date ' + (i + 1)" />
                  <button type="button" class="vs-pedit__icon-btn is-danger" (click)="removePortRow(kind.key, i)"
                    [disabled]="isSavingPorts" [title]="'Remove ' + kind.label + ' port'"
                    [attr.aria-label]="'Remove ' + kind.label + ' port ' + (i + 1)">
                    <mat-icon>remove_circle_outline</mat-icon>
                  </button>
                </div>
                <button type="button" class="vs-pedit__add" *ngIf="portEdit[kind.key].length < maxPortsPerKind"
                  (click)="addPortRow(kind.key)" [disabled]="isSavingPorts">
                  <mat-icon>add_circle_outline</mat-icon>
                  Add {{ kind.label }} port
                </button>
              </div>
            </div>
            <footer class="vs-pedit__foot">
              <span class="vs-pedit__hint" [class.is-error]="hasInvalidPortRows">
                {{ hasInvalidPortRows ? 'Enter a port name for every dated row' : 'Saves to the voyage itinerary' }}
              </span>
              <button type="button" class="vs-btn vs-pedit__btn" (click)="cancelPortEdit()" [disabled]="isSavingPorts">
                Cancel
              </button>
              <button type="button" class="vs-btn vs-btn--primary vs-pedit__btn" (click)="savePortEdit()"
                [disabled]="isSavingPorts || hasInvalidPortRows">
                <mat-icon>{{ isSavingPorts ? 'hourglass_empty' : 'save' }}</mat-icon>
                {{ isSavingPorts ? 'Saving…' : 'Save' }}
              </button>
            </footer>
          </div>

          <ng-template #vsPortRoute>
            <ol class="vs-route" *ngIf="modalInsights?.stops?.length; else vsNoPorts">
              <li class="vs-route__stop" *ngFor="let stop of modalInsights?.stops"
                [ngClass]="['is-' + stop.kind, 'is-' + stop.state]">
                <span class="vs-route__dot" aria-hidden="true">
                  <mat-icon *ngIf="stop.state === 'done'">check</mat-icon>
                </span>
                <span class="vs-route__name">{{ stop.name }}</span>
                <span class="vs-route__kind">{{ stop.kind === 'load' ? 'Load' : 'Discharge' }}</span>
                <span class="vs-route__next" *ngIf="stop.state === 'next'">Next</span>
                <span class="vs-route__date" [class.is-invalid]="stop.rawDate && stop.time === null"
                  [title]="stop.rawDate && stop.time === null ? 'Date looks invalid: ' + stop.rawDate : ''">
                  {{ stop.time !== null ? formatEpochDate(stop.time) : (stop.rawDate || '—') }}
                </span>
              </li>
            </ol>
          </ng-template>
          <ng-template #vsNoPorts>
            <p class="vs-ports__empty vs-ports__empty--pad">No port schedule recorded yet.</p>
          </ng-template>
        </section>

        <!-- Heat plans (active voyages only) -->
        <section class="vs-tile vs-tile--heatplans" *ngIf="!isSpecialVoyage && modalHeatplans as hp">
          <header class="vs-tile__head">
            <span class="vs-tile__icon"><mat-icon>whatshot</mat-icon></span>
            <h4>
              Heat plans <b class="vs-tile__count">{{ hp.count }}</b>
              <span class="vs-due vs-due--chip" *ngIf="modalElement.hp_due as due" [ngClass]="'is-' + due.level"
                [title]="heatplanDueTitle(due)">
                <span class="vs-due__dot" aria-hidden="true"></span>
                <b>{{ due.label }}</b>
                <small *ngIf="due.dueTime !== null">· by {{ formatDueDate(due.dueTime) }}</small>
                <small *ngIf="due.port">· {{ due.port.arriving ? 'arrives' : 'arrived' }} {{
                  formatDueDate(due.port.arrival) }}</small>
              </span>
            </h4>
            <span class="vs-hp__summary" *ngIf="hp.rows.length">
              {{ formatHeatplanDate(hp.spanStart) }} → {{ formatHeatplanDate(hp.spanEnd) }}
              <span class="vs-hp__dot" aria-hidden="true"></span>
              {{ hp.spanDays }} {{ hp.spanDays === 1 ? 'day' : 'days' }} covered
            </span>
            <button type="button" class="vs-copy" (click)="copyTileData('heatplans', $event)"
              [class.is-copied]="copiedTile === 'Heat Plans'"
              [title]="copiedTile === 'Heat Plans' ? 'Copied data to clipboard' : 'Copy formatted tile data'">
              <mat-icon>{{ copiedTile === 'Heat Plans' ? 'check' : 'content_copy' }}</mat-icon>
              <span>{{ copiedTile === 'Heat Plans' ? 'Copied' : 'Copy' }}</span>
            </button>
          </header>

          <ol class="vs-hp" *ngIf="hp.rows.length; else vsNoHeatplans" aria-label="Heat plan timeline">
            <li class="vs-hp__row" *ngFor="let plan of hp.rows" [ngClass]="'is-' + plan.state">
              <span class="vs-hp__name">Plan {{ plan.plan_number }}</span>
              <span class="vs-hp__track">
                <span class="vs-hp__today" *ngIf="hp.todayPct !== null" [style.left.%]="hp.todayPct"
                  aria-hidden="true"></span>
                <span class="vs-hp__bar" [style.left.%]="plan.left" [style.width.%]="plan.width"></span>
              </span>
              <span class="vs-hp__dates">{{ formatHeatplanDate(plan.start_date) }} → {{
                formatHeatplanDate(plan.end_date) }}</span>
              <span class="vs-hp__days">{{ plan.days }} {{ plan.days === 1 ? 'day' : 'days' }}</span>
              <!-- Arriving at / in a discharge port today: say where the vessel is on the latest plan's row -->
              <span class="vs-hp__state vs-hp__state--port" *ngIf="portOnLatestPlan(plan) as port; else planState"
                [title]="(port.arriving ? 'Vessel arrives at ' : 'Vessel is at ') + port.name + ' (arrival ' + formatEpochDate(port.arrival) + '). Heat plans are not sent while in port.'">
                <mat-icon>{{ port.arriving ? 'directions_boat' : 'anchor' }}</mat-icon>{{ port.arriving ? 'Arriving'
                : 'At' }} {{ port.name }}
              </span>
              <ng-template #planState>
                <span class="vs-hp__state">
                  {{ plan.state === 'active' ? 'Active' : plan.state === 'upcoming' ? 'Upcoming' : 'Completed' }}
                </span>
              </ng-template>
            </li>
          </ol>
          <ng-template #vsNoHeatplans>
            <p class="vs-hp__empty">No heat plans created for this voyage yet.</p>
          </ng-template>
        </section>
      </div>

      <footer class="vs-dialog__foot">
        <span class="vs-dialog__hint">
          <span class="vs-dialog__esc"><kbd>Esc</kbd> to close ·</span>
          <span
            matTooltip="Today, heat plan dues and port calls follow the Indian Standard Time (UTC+5:30) calendar date"
            matTooltipPosition="above">Dates in IST (UTC+5:30)</span>
        </span>
        <button type="button" class="vs-btn" (click)="openVoyageMonitoring(modalElement, $event); closeDetailsModal()">
          <mat-icon>monitor_heart</mat-icon>
          <span>Voyage monitoring</span>
        </button>
        <button type="button" class="vs-btn vs-btn--primary" (click)="editRow(modalElement); closeDetailsModal()">
          <span>View Plan</span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </footer>
    </div>
  </div>

  <!-- ======================= Opening a voyage ======================= -->
  <div class="vs-overlay vs-overlay--nav" *ngIf="isNavigatingRow">
    <div class="vs-nav-card" role="status" aria-live="polite">
      <div class="vs-nav-card__spinner"></div>
      <h4>Getting voyage details</h4>
      <p *ngIf="navigatingVesselName">Opening <strong>{{ navigatingVesselName }}</strong>…</p>
      <div class="vs-nav-card__skeleton">
        <app-ch-skeleton variant="form" [rows]="0"></app-ch-skeleton>
      </div>
    </div>
  </div>
</div>